// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"578":"f45daa58","703":"d4a05cf9"}[chunkId] + ".chunk.js";
};